/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Integrations_RunsInputs */

const cs_integrations_runs = /** @type {(inputs: Integrations_RunsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronizace (${i?.count})`)
};

const en_integrations_runs = /** @type {(inputs: Integrations_RunsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sync runs (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Sync runs ({count})" |
*
* @param {Integrations_RunsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_runs = /** @type {((inputs: Integrations_RunsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_RunsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_runs(inputs)
	return cs_integrations_runs(inputs)
});